/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { Store } from 'redux';
import { IPropertiesValidator } from './ValidatorTypes';
import { IState } from '../store/types/StateTypes';
import MetadataState from '../enums/MetadataState';

class ParameterValueValidator implements IPropertiesValidator {
    currentStore: Store;

    constructor(store: Store) {
        this.currentStore = store;
    }

    validate(properties: any) {
        const state: IState = this.currentStore.getState();
        const params = (properties && properties.params) || state.params;

        if (params && state.metadataState !== MetadataState.LOADING && (state.levelsLayout.rows.length || state.levelsLayout.columns.length)) {
            const parameterInError = state.filterParameters.find((parameter) => (
                !(!parameter.singleValue || !params[parameter.name] || params[parameter.name].length)
            ));

            if (parameterInError) {
                return {
                    message: `Parameter ${parameterInError.name} must have value.`,
                    errorCode: 'parameter.value.missing',
                    parameters: [parameterInError.name]
                }
            }
        }
        return null;
    }
}

export default ParameterValueValidator;
